export const MEDICAL_DISCHARGE_ROUTES = {
  lightRegimeForm                 : 'formulario/regimen/liviano',
  papillaryRegimeForm             : 'formulario/regimen/papilla',
  epicrisisNursingForm            : 'formulario/epicrisis/enfermeria',
  residueFreeRegimenForm          : 'formulario/regimen/sin-residuos',
  historyPatientDischargeDocs     : 'historial/formularios/regímenes/paciente',
  historyProfessionalDischargeDocs: 'historial/formularios/regímenes/profesional',
};
